import React from 'react';
import classnames from 'classnames/bind';
import { LogoCaption } from '../../NavigationSideBar/components/NavigationSideBarLogo/LogoCaption';
import styles from './Logo.module.scss';

const classNameBuilder = classnames.bind(styles);

const Logo = ({ className }) => {
    return (
        <div className={classNameBuilder('container', className)} aria-label="Taboola Ads Logo">
            <LogoCaption />
        </div>
    );
};

export default Logo;
